import { useIsMobile } from './useIsMobile';
import { useTranslations } from './useTranslations';

export const useSearchInputPlaceholder = () => {
  const isMobile = useIsMobile();
  const { translations } = useTranslations();

  return isMobile ? translations.search : translations.searchDesktop;
};
